import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	error: {
		id: 'version-picker.error',
		defaultMessage: "We couldn't retrieve versions",
		description:
			'Message showed in version picker when there is an error while loading options from server.',
	},
	placeholder: {
		id: 'version-picker.placeholder',
		defaultMessage: 'Select version',
		description: 'Message showed in version picker placeholder when no option is selected.',
	},
});
